// @spec GHG-STR-006
'use client';

import { Link, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { SCOPE3_CATEGORY_BY_SLUG } from '@/features/ghg/config/scope3-categories';
import { GhgScope3CalculationsPage } from '@/features/ghg/pages/GhgScope3CalculationsPage';

export const Route = createFileRoute('/_authenticated/ghg/scope3/$category/')({
  component: Scope3CategoryPage,
  notFoundComponent: Scope3CategoryNotFound,
});

function Scope3CategoryPage() {
  const { category } = Route.useParams();
  const config = SCOPE3_CATEGORY_BY_SLUG.get(category);

  if (!config) {
    return <Scope3CategoryNotFound />;
  }

  return <GhgScope3CalculationsPage fixedScope3Category={config.number} />;
}

function Scope3CategoryNotFound() {
  const { t } = useTranslation('ghg');
  return (
    <div className="p-8">
      <div className="mx-auto max-w-3xl space-y-6">
        <header>
          <h1 className="text-3xl font-semibold text-foreground">{t('scope3CategoryNotFound.heading')}</h1>
          <p className="mt-2 text-muted-foreground">
            {t('scope3CategoryNotFound.description')}
          </p>
        </header>
        <Link className="text-sm text-primary underline" to="/ghg/calculations/scope3">
          {t('scope3CategoryNotFound.link_openCategories')}
        </Link>
      </div>
    </div>
  );
}
